import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class OutroService {

  public OUTRO_REASON_TIMEISUP = "TIMEISUP"
  public OUTRO_REASON_USERSUBMIT = "USERSUBMIT"

  public router = inject(Router);
  public outroReason = this.OUTRO_REASON_TIMEISUP;

  constructor() { }

  public navigateToOutro(reason: string) {
    this.outroReason = reason;
    this.router.navigate(["/outro"]);
  }

}
